module.exports = __webpack_public_path__ + "img/savvycal.84739051.svg";